import React, { useState } from "react";
import api from "../../services/api.js";

export default function ModalCreateUserStory({
  isOpen,
  onClose,
  epicId,
  projectId,
  users,
  onSuccess,
}) {
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!subject.trim()) {
      setError("O título da história é obrigatório.");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        project: Number(projectId),
        subject: subject.trim(),
        description: description.trim() || undefined,
        assigned_to: assignedTo ? Number(assignedTo) : undefined,
        epic: epicId ? Number(epicId) : undefined,
      };

      const response = await api.post("/createUserStory", payload);

      // Sucesso - fechar modal e limpar
      setSubject("");
      setDescription("");
      setAssignedTo("");
      onClose();

      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (err) {
      console.error("Erro ao criar história de usuário:", err);
      setError(
        err.response?.data?.error ||
          "Erro ao criar história de usuário. Tente novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={() => !loading && onClose()}
    >
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: 12,
          padding: 24,
          maxWidth: 700,
          width: "90%",
          boxShadow: "0 20px 25px rgba(0,0,0,0.15)",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#111827" }}>
            Criar História de Usuário
          </h2>
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            style={{
              background: "none",
              border: "none",
              fontSize: 24,
              cursor: loading ? "not-allowed" : "pointer",
              color: "#6B7280",
              padding: 0,
              width: 32,
              height: 32,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ✕
          </button>
        </div>

        {/* Error message */}
        {error && (
          <div
            style={{
              background: "#FEE2E2",
              color: "#991B1B",
              padding: 12,
              borderRadius: 8,
              marginBottom: 16,
              fontSize: 13,
            }}
          >
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {/* Subject */}
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <label
              htmlFor="subject"
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: "#374151",
              }}
            >
              Título da História *
            </label>
            <input
              id="subject"
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Ex: Como usuário, desejo..."
              disabled={loading}
              style={{
                padding: "8px 12px",
                border: "1px solid #D1D5DB",
                borderRadius: 8,
                fontSize: 13,
                fontFamily: "inherit",
                color: "#111827",
                outline: "none",
              }}
            />
          </div>

          {/* Description */}
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <label
              htmlFor="description"
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: "#374151",
              }}
            >
              Descrição (opcional)
            </label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Descreva os detalhes da história..."
              disabled={loading}
              rows={4}
              style={{
                padding: "8px 12px",
                border: "1px solid #D1D5DB",
                borderRadius: 8,
                fontSize: 13,
                fontFamily: "inherit",
                color: "#111827",
                outline: "none",
                resize: "vertical",
              }}
            />
          </div>

          {/* Assigned To */}
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <label
              htmlFor="assignedTo"
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: "#374151",
              }}
            >
              Atribuir a (opcional)
            </label>
            <select
              id="assignedTo"
              value={assignedTo}
              onChange={(e) => setAssignedTo(e.target.value)}
              disabled={loading}
              style={{
                padding: "8px 12px",
                border: "1px solid #D1D5DB",
                borderRadius: 8,
                fontSize: 13,
                fontFamily: "inherit",
                color: "#111827",
                outline: "none",
                backgroundColor: "#FFFFFF",
              }}
            >
              <option value="">Nenhum</option>
              {Array.isArray(users) &&
                users.map((user) => (
                  <option key={user.id_colaborador} value={user.id_colaborador}>
                    {user.nome_colaborador}
                  </option>
                ))}
            </select>
          </div>

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              gap: 12,
              marginTop: 8,
              justifyContent: "flex-end",
            }}
          >
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                padding: "8px 16px",
                border: "1px solid #D1D5DB",
                borderRadius: 8,
                background: "#FFFFFF",
                color: "#374151",
                fontSize: 13,
                fontWeight: 600,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "background 0.15s",
              }}
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: "8px 16px",
                border: "none",
                borderRadius: 8,
                background: loading ? "#9CA3AF" : "#1D4ED8",
                color: "#FFFFFF",
                fontSize: 13,
                fontWeight: 600,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "background 0.15s",
              }}
            >
              {loading ? "Criando..." : "Criar História"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
